import BotResponseTreeNode from './BotResponseTreeNode';
import ComparisonOperator from './ComparisonOperator';

class ConditionalTreeNode {
  intentSlotId: number | null;

  slotName: string | null; // The name of the slot in the intent - intentSlot.slotName

  slotType: string | null; // The name of the slot globally - slot.slotName

  comparisonOperator: ComparisonOperator | null;

  comparisonValue: string | null;

  trueStep: BotResponseTreeNode | null;

  falseStep: BotResponseTreeNode | null;

  constructor(
    intentSlotId: number | null,
    slotName: string | null,
    slotType: string | null,
    comparisonOperator: ComparisonOperator | null,
    comparisonValue: string | null,
    trueStep: BotResponseTreeNode | null,
    falseStep: BotResponseTreeNode | null
  ) {
    this.intentSlotId = intentSlotId;
    this.slotName = slotName;
    this.slotType = slotType;
    this.comparisonOperator = comparisonOperator;
    this.comparisonValue = comparisonValue;
    this.trueStep = trueStep;
    this.falseStep = falseStep;
  }
}

export default ConditionalTreeNode;
